/** Partner API status: 1 Active, 2 Pending, 3 Inactive (aligned with PartnerList). */
export function toPartnerApiStatus(value, defaultStatus = 1) {
    if (value === 1 || value === 2 || value === 3) return value;
    if (value === "1" || value === "2" || value === "3") return Number(value);
    if (typeof value === "string") {
        const v = value.trim().toLowerCase();
        if (v === "active") return 1;
        if (v === "pending") return 2;
        if (v === "inactive") return 3;
    }
    const n = Number(value);
    if (n === 1 || n === 2 || n === 3) return n;
    return defaultStatus;
}
